const GettingStartedPage = () =>
  import(/* webpackChunkName: "sheets-getting-started-page" */ './pages/GettingStartedPage');
const TemplatesPage = () =>
  import(/* webpackChunkName: "sheets-templates-page" */ './pages/TemplatesPage');

export const sheetsRoute = [
  {
    path: '/sheets/gettingstarted',
    name: 'sheetsgettingstarted',
    component: GettingStartedPage,
  },
  {
    path: '/sheets/templates',
    name: 'sheetstemplates',
    component: TemplatesPage,
  },
];
